export default "__VITE_ASSET__MVDRshpH__"